import React from 'react';

const LoadinPage = () => {
    return (
        <div className="w-full h-full flex items-center justify-center">
            LOADING...
        </div>
    );
};

export default LoadinPage;